module.exports = __webpack_public_path__ + "static/media/dragdropimage.5aab4324.png";